import { useState } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES, CATEGORY_LABELS } from "../lib/constants";
import { useBrand } from "../context/BrandContext";
import { UnsubscribeModal } from "./UnsubscribeModal";

export function Footer() {
    const brand = useBrand();
    const [unsubOpen, setUnsubOpen] = useState(false);

    return (
        <footer className="bg-ink text-white mt-20" data-testid="footer">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
                    {/* Brand / contact */}
                    <div className="col-span-2 lg:col-span-1">
                        <div className="flex items-baseline gap-1">
                            <span className="font-serif text-2xl font-black leading-none">{brand.site_name}</span>
                            <span className="w-2 h-2 bg-accent" />
                        </div>
                        <p className="mt-3 text-sm text-white/60 leading-relaxed max-w-xs">{brand.tagline}</p>
                        <p className="mt-4 font-mono text-xs text-white/50" data-testid="footer-contact-email">{brand.email}</p>
                        {brand.phone && <p className="mt-1 font-mono text-xs text-white/50">{brand.phone}</p>}
                    </div>

                    {/* Sections */}
                    <div>
                        <h5 className="font-mono text-[11px] font-bold uppercase tracking-widest text-white/40 mb-3">Sections</h5>
                        <ul className="space-y-2">
                            {CATEGORIES.map((c) => (
                                <li key={c}>
                                    <Link to={`/category/${c}`} className="text-sm text-white/80 hover:text-accent transition-colors duration-150">
                                        {CATEGORY_LABELS[c]}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company */}
                    <div>
                        <h5 className="font-mono text-[11px] font-bold uppercase tracking-widest text-white/40 mb-3">Company</h5>
                        <ul className="space-y-2">
                            <li><Link to="/advertise" data-testid="footer-advertise" className="text-sm text-white/80 hover:text-accent transition-colors duration-150">Advertise with us</Link></li>
                            <li><Link to="/archive" className="text-sm text-white/80 hover:text-accent transition-colors duration-150">Archive</Link></li>
                            <li><Link to="/privacy" data-testid="footer-privacy" className="text-sm text-white/80 hover:text-accent transition-colors duration-150">Privacy Policy</Link></li>
                            <li><Link to="/terms" data-testid="footer-terms" className="text-sm text-white/80 hover:text-accent transition-colors duration-150">Terms of Use</Link></li>
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <h5 className="font-mono text-[11px] font-bold uppercase tracking-widest text-white/40 mb-3" data-testid="footer-newsletter-title">Newsletter</h5>
                        <p className="text-sm text-white/60 leading-relaxed">Get the latest financial news delivered to your inbox.</p>
                        <Link
                            to="/register"
                            data-testid="footer-newsletter-subscribe"
                            className="mt-4 inline-block bg-accent text-white px-5 py-2.5 font-mono text-[11px] uppercase tracking-widest hover:bg-white hover:text-ink transition-colors duration-150"
                        >
                            Subscribe
                        </Link>
                        <button
                            onClick={() => setUnsubOpen(true)}
                            data-testid="footer-unsubscribe"
                            className="mt-3 block text-xs text-white/50 hover:text-accent transition-colors duration-150"
                        >
                            Unsubscribe
                        </button>
                    </div>
                </div>

                <div className="border-t border-white/15 mt-10 pt-5">
                    <p className="font-mono text-xs text-white/40">
                        © {new Date().getFullYear()} {brand.site_name} · {brand.domain}
                    </p>
                </div>
            </div>
            <UnsubscribeModal open={unsubOpen} onOpenChange={setUnsubOpen} />
        </footer>
    );
}
